@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap');

@tailwind base;
@tailwind components;
@tailwind utilities;

:root {
  --background-50: 0.98 0.002 260;
  --background-100: 0.95 0.005 260;
  --background-200: 0.89 0.008 260;
  --background-300: 0.80 0.010 260;
  --background-400: 0.68 0.012 260;
  --background-500: 0.55 0.015 260;
  --background-600: 0.42 0.015 255;
  --background-700: 0.32 0.018 250;
  --background-800: 0.22 0.020 248;
  --background-900: 0.16 0.018 245;
  --background-950: 0.10 0.015 240;
  --primary-50: 0.96 0.010 255;
  --primary-100: 0.90 0.025 255;
  --primary-200: 0.82 0.045 255;
  --primary-300: 0.72 0.065 255;
  --primary-400: 0.62 0.085 255;
  --primary-500: 0.52 0.105 255;
  --primary-600: 0.44 0.110 255;
  --primary-700: 0.36 0.108 252;
  --primary-800: 0.28 0.095 250;
  --primary-900: 0.22 0.075 248;
  --primary-950: 0.15 0.055 245;
  --accent-50: 0.96 0.015 185;
  --accent-100: 0.91 0.038 185;
  --accent-200: 0.84 0.065 185;
  --accent-300: 0.74 0.082 185;
  --accent-400: 0.64 0.090 185;
  --accent-500: 0.55 0.088 185;
  --accent-600: 0.48 0.080 185;
  --accent-700: 0.40 0.068 185;
  --accent-800: 0.32 0.052 185;
  --accent-900: 0.25 0.038 185;
  --accent-950: 0.18 0.025 185;
  --secondary-50: 0.96 0.003 260;
  --secondary-100: 0.92 0.006 260;
  --secondary-200: 0.85 0.010 260;
  --secondary-300: 0.74 0.014 260;
  --secondary-400: 0.62 0.016 260;
  --secondary-500: 0.50 0.018 260;
  --secondary-600: 0.42 0.018 260;
  --secondary-700: 0.34 0.016 260;
  --secondary-800: 0.26 0.014 260;
  --secondary-900: 0.20 0.012 260;
  --secondary-950: 0.14 0.010 260;
  --foreground-50: 0.98 0.001 260;
  --foreground-100: 0.92 0.002 260;
  --foreground-200: 0.82 0.003 260;
  --foreground-300: 0.70 0.005 260;
  --foreground-400: 0.58 0.006 260;
  --foreground-500: 0.46 0.007 260;
  --foreground-600: 0.38 0.008 260;
  --foreground-700: 0.30 0.008 260;
  --foreground-800: 0.22 0.009 260;
  --foreground-900: 0.15 0.008 260;
  --foreground-950: 0.08 0.007 260;
  --font-body: 'Inter', system-ui, sans-serif;
  --font-heading: 'Inter', system-ui, sans-serif;
  --font-label: 'Inter', system-ui, sans-serif;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: var(--font-body);
  background-color: oklch(var(--background-50));
  color: oklch(var(--foreground-800));
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background: oklch(var(--secondary-300));
  border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
  background: oklch(var(--secondary-400));
}

.sidebar-scroll::-webkit-scrollbar {
  width: 4px;
}

.sidebar-scroll::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.15);
  border-radius: 2px;
}

.antispam-field {
  position: absolute;
  left: -9999px;
  opacity: 0;
  height: 0;
  width: 0;
  overflow: hidden;
  pointer-events: none;
}